function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useContext } from 'react';
import { connect } from 'react-redux';
import { modalActions } from '../../../reducers/modal.reducer';
import { cmsActions } from '../../../reducers/cms.reducer';
import { posActions } from '../../../reducers/pos.reducer';
import RichTextEditor from 'react-rte';
import PageData from './Page.context';
import UploadImage from '../../common/assets/UploadImage.modal';
import Card from '../../common/card/Card.react';
import CardHeader from '../../common/card/CardHeader.react';
import CardBody from '../../common/card/CardBody.react';
import AssetViewer from '../../assets/AssetViewer.modal';
import Cropper from '../../common/Cropper.react';
import Checkbox from '../../common/form/Checkbox.react';
import Button from '../../common/Button.react';
import AzureBlob from '../../common/AzureBlob.react';
import AltTag from '../../common/form/AltTag.react';
var PageBanner = function PageBanner(_ref) {
  var addModalAction = _ref.addModalAction,
    removeModalAction = _ref.removeModalAction,
    pageAssetAction = _ref.pageAssetAction,
    pagesAction = _ref.pagesAction;
  var _useContext = useContext(PageData),
    _useContext2 = _slicedToArray(_useContext, 2),
    state = _useContext2[0],
    setState = _useContext2[1];
  var pageID = state.pageID,
    pageType = state.type,
    articleType = state.articleType,
    banner = state.banner,
    archived = state.archived;
  var assetID = banner.assetID,
    isVisible = banner.isVisible,
    filename = banner.filename,
    paragraph = banner.paragraph,
    logo = banner.logo,
    altTag = banner.altTag;
  var _useState = useState({
      visible: false,
      asset: null,
      assetID: null,
      reCrop: false,
      filename: null
    }),
    _useState2 = _slicedToArray(_useState, 2),
    cropper = _useState2[0],
    setCropper = _useState2[1];
  if (pageType === 'react-component') return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Page Banner"
  }), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Checkbox, {
    checked: isVisible,
    label: "Show Banner",
    onChange: function onChange(v) {
      setState(_objectSpread(_objectSpread({}, state), {}, {
        banner: _objectSpread(_objectSpread({}, banner), {}, {
          isVisible: v
        })
      }));
      pagesAction({
        formData: {
          isVisible: v,
          pageID: pageID
        },
        method: 'put',
        route: 'banner-details'
      });
    },
    permission: "edit-pos-sections"
  })), isVisible && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Banner Image"
  }), /*#__PURE__*/React.createElement(CardBody, null, filename && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "a-img__img"
  }, /*#__PURE__*/React.createElement("div", {
    className: "a-img__img--body",
    style: {
      width: 1400,
      height: 490
    }
  }, /*#__PURE__*/React.createElement(AzureBlob, {
    filename: filename,
    assetID: assetID
  })), /*#__PURE__*/React.createElement(AltTag, {
    altTag: altTag,
    tagType: "page-banner",
    appType: "pos",
    pageID: pageID,
    onChange: function onChange(e) {
      return setState(_objectSpread(_objectSpread({}, state), {}, {
        banner: _objectSpread(_objectSpread({}, banner), {}, {
          altTag: e.target.value
        })
      }));
    }
  })), !archived && /*#__PURE__*/React.createElement("div", {
    className: "a__btns"
  }, /*#__PURE__*/React.createElement(Button, {
    label: "Delete",
    type: "delete",
    requireConfirmation: true,
    icon: "lock-icon@3x.png",
    onClick: function onClick() {
      pageAssetAction({
        formData: {
          assetID: assetID,
          type: 'pageBanner',
          pageID: pageID,
          filename: filename
        },
        method: 'delete'
      });
    },
    permission: "edit-pos-sections"
  }), /*#__PURE__*/React.createElement(Button, {
    label: "Re-Crop",
    onClick: function onClick() {
      setCropper(_objectSpread(_objectSpread({}, cropper), {}, {
        assetID: assetID,
        visible: true,
        reCrop: true,
        filename: filename
      }));
    },
    permission: "edit-pos-sections"
  }))), !filename && !archived && /*#__PURE__*/React.createElement("div", {
    className: "a__btns"
  }, /*#__PURE__*/React.createElement(Button, {
    label: "Add",
    onClick: function onClick() {
      addModalAction({
        component: /*#__PURE__*/React.createElement(UploadImage, {
          onUploaded: function onUploaded(img) {
            setCropper(_objectSpread(_objectSpread({}, cropper), {}, {
              asset: img,
              visible: true,
              reCrop: false,
              filename: null
            }));
            removeModalAction();
          },
          disableSelectImageType: true
        })
      });
    },
    permission: "edit-pos-sections"
  })), /*#__PURE__*/React.createElement(Cropper, {
    visible: cropper.visible,
    asset: cropper.asset,
    assetID: cropper.assetID,
    type: "pageBanner",
    onClose: function onClose() {
      return setCropper(_objectSpread(_objectSpread({}, cropper), {}, {
        visible: false
      }));
    },
    onCrop: function onCrop(_ref2) {
      var crop = _ref2.crop,
        assetID = _ref2.assetID;
      pageAssetAction({
        formData: {
          id: null,
          type: 'pageBanner',
          pageID: pageID,
          assetID: assetID,
          filename: cropper.filename,
          crop: {
            x: crop.x,
            y: crop.y,
            w: crop.width,
            h: crop.height
          }
        },
        method: cropper.reCrop ? 'put' : 'post'
      });
      setCropper({
        visible: false,
        asset: null,
        assetID: null,
        reCrop: false,
        filename: null
      });
    }
  })), articleType === 'project' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Logo"
  }), /*#__PURE__*/React.createElement(CardBody, null, !(logo !== null && logo !== void 0 && logo.assetID) ? /*#__PURE__*/React.createElement("div", {
    className: "a__btns"
  }, !archived && /*#__PURE__*/React.createElement(Button, {
    label: "Select Logo",
    onClick: function onClick() {
      addModalAction({
        component: /*#__PURE__*/React.createElement(AssetViewer, {
          onSelect: function onSelect(asset) {
            pagesAction({
              formData: {
                assetID: asset._id,
                pageID: pageID
              },
              method: 'put',
              route: 'banner-details'
            });
          },
          type: "logo"
        })
      });
    },
    style: {
      width: 120,
      marginTop: 10
    },
    permission: "edit-pos-sections"
  })) : /*#__PURE__*/React.createElement(AzureBlob, {
    filename: logo.assetID.filename,
    assetID: logo.assetID._id,
    style: {
      height: 55
    }
  })), /*#__PURE__*/React.createElement(CardHeader, {
    title: "Paragraph"
  }), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(RichTextEditor, {
    value: paragraph,
    className: "a-editor__editor",
    onChange: function onChange(val) {
      setState(_objectSpread(_objectSpread({}, state), {}, {
        banner: _objectSpread(_objectSpread({}, banner), {}, {
          paragraph: val
        })
      }));
    }
  }), !archived && /*#__PURE__*/React.createElement("div", {
    className: "a__btns"
  }, /*#__PURE__*/React.createElement(Button, {
    label: "Save",
    onClick: function onClick() {
      pagesAction({
        formData: {
          paragraph: (paragraph === null || paragraph === void 0 ? void 0 : paragraph.toString('html')) || null,
          pageID: pageID
        },
        method: 'put',
        route: 'banner-details'
      });
    },
    permission: "edit-pos-sections"
  })))))));
};
var mdtp = {
  addModalAction: modalActions.add,
  removeModalAction: modalActions.remove,
  pageAssetAction: cmsActions.pageAsset,
  pagesAction: posActions.pages
};
export default connect(null, mdtp)(PageBanner);